module.exports = __webpack_public_path__ + "img/item_Story_20.bd2a02d3.jpeg";